import apiClient from '@/services/apiClient'
import {
    SEARCHACTION_QUOTES,
    SEARCHACTION_EDIT_CUSTOMER_REFERENCE,
    SEARCHACTION_EDIT_PARTS,
    SEARCHACTION_AND_QUOTE_QUOTE_TYPES,
    SEARCHACTION_INVENTORY,
    SEARCHACTION,
} from '@/data/url'

const createSearchAction = ({
    part_numbers,
    quantity,
    customer,
    customer_ref,
    quote_type,
    substitutes,
    due_date,
}) =>
    apiClient.post(SEARCHACTION_QUOTES, {
        part_numbers,
        quantity,
        substitutes: substitutes || {
            all_parts: [],
            master_substitutes: {},
            substitute_parent_map: {},
            substitute_tree: [],
        },
        customer,
        customer_ref,
        quote_type,
        due_date: due_date || null,
    })

const createSearchActionAndQuotes = (payload) => apiClient.post(SEARCHACTION_QUOTES, payload)

const createSearchOnlyAction = ({
    part_numbers,
    customer,
    customer_ref,
    quote_type,
    substitutes,
    due_date,
}) =>
    apiClient.post(SEARCHACTION, {
        part_number_list: part_numbers,
        part_and_sub_list: substitutes?.all_parts || part_numbers,
        master_subs_dict: substitutes?.master_substitutes || {},
        customer,
        customer_ref,
        quote_type,
        due_date: due_date || null,
    })

const updateCustomerReference = ({ id, customer, customer_ref }) =>
    apiClient.patch(SEARCHACTION_EDIT_CUSTOMER_REFERENCE, {
        id,
        customer,
        customer_ref,
    })

const updateParts = ({ search_action_id, part_number_list, new_parts_list, changed_parts_dict }) =>
    apiClient.patch(SEARCHACTION_EDIT_PARTS, {
        search_action_id,
        part_number_list,
        new_parts_list,
        changed_parts_dict,
    })

const patchSearchActionQuoteTypes = ({ id, payload }) =>
    apiClient.patch(SEARCHACTION_AND_QUOTE_QUOTE_TYPES.replace('{id}', id), payload)

const getInventory = (id) => apiClient.get(SEARCHACTION_INVENTORY.replace('{id}', id))

export default {
    updateCustomerReference,
    updateParts,
    patchSearchActionQuoteTypes,
    createSearchAction,
    createSearchActionAndQuotes,
    createSearchOnlyAction,
    getInventory,
}
